import orderApi from '@/api/order'
import { generateFormHandlerMutations } from '@/helpers/forms'

const state = {
  idempotencyKey: '',
  receiverAvailable: false,
  callbacks: [],
  loading: false,
  loaded: false,
}

const getters = {}

const actions = {
  async fetchLog({ commit }, id) {
    commit('SET_LOADING')
    try {
      const { data } = await orderApi.getPaymentLog(id)
      commit('SET_LOG', data)
    } catch {
      commit('SET_LOG', { receiverAvailable: false, callbacks: [] })
    }
  },
}

const mutations = {
  SET_LOADING(state) {
    state.loading = true
  },
  SET_LOG(state, data) {
    state.idempotencyKey = data.idempotencyKey
    state.receiverAvailable = data.receiverAvailable
    state.callbacks = data.callbacks || []
    state.loading = false
    state.loaded = true
  },
  ...generateFormHandlerMutations(state),
}

const modules = {}

const watchers = []

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules,
  watchers,
}
